import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const GumruklendiBilgisi = () => {
    return (
        <div>
            <ExcelUpload
                requiredColumnsSase={["sase", "Beyanname No", "Tarih"]}
                process_type="CUSTOMS_CLEARANCE"
                ExcelName={"Gümrüklendi Bilgisi Hatalı Şaseler"}
                Title={"Gümrüklendi Bilgisi"}
                exampleData={[{
                    sase: "VF3YEF6F0RMA03711"
                }]}
                role_name={"gumruklendi_bilgisi_write"}
            />
        </div>
    )
}

export default GumruklendiBilgisi